<template>
    <modal :show.sync=show modalClasses="medium-sized-modal modal-hide-footer">
        <h3 slot="header" class="mb-0 font-weight-500">Edit Hub Details</h3>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form role="form">
                <b-row>
                    <b-col cols="12">
                        <b-form-group>
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'hubType'"
                            >
                                <el-radio-group v-model="form.hub_type_id">
                                    <el-radio :label="1" style="line-height: 0;">
                                        <b-iconstack font-scale="2" style="vertical-align: middle;">
                                            <b-icon stacked icon="square-fill" variant="success"></b-icon>
                                            <b-icon stacked icon="basket2" scale="0.5" class="text-white"></b-icon>
                                        </b-iconstack>
                                        <span style="vertical-align: middle;" class="mx-2 font-weight-400">Green Basket</span>
                                    </el-radio>
                                    <el-radio :label="2" style="line-height: 0;">
                                        <b-iconstack font-scale="2" style="vertical-align: middle;">
                                            <b-icon stacked icon="square-fill" style="color: #f2a818 !important"></b-icon>
                                            <b-icon stacked icon="basket2" scale="0.5" class="text-white"></b-icon>
                                        </b-iconstack>
                                        <span style="vertical-align: middle;" class="mx-2 font-weight-400">Yellow Basket</span>
                                    </el-radio>
                                </el-radio-group>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Hub Name">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'hubName'"
                            >
                                <b-form-input
                                v-model="form.hub_name"
                                placeholder="Enter Hub Name"
                                required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Hub Manager">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'hubManager'"
                            >
                                <el-select v-model="form.user_id" filterable placeholder="Select Hub Manager">
                                    <el-option v-for="option in selectHubManagerOptions"
                                        :key="option.id"
                                        :label="option.name"
                                        :value="option.id">
                                    </el-option>
                                </el-select>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group> 
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Hub Address">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'hubAddress'"
                            >
                                <b-form-textarea
                                v-model="form.hub_address"
                                rows="3"
                                ></b-form-textarea>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Target Revenue Point (RM):">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true, currency: true }"
                                :vid="'hubTarget'"
                            >
                                <b-form-input
                                    v-model="form.hub_target"
                                    placeholder="Enter target"
                                    type="text"
                                    required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="mx-auto text-center mt-4 pt-2">
                        <b-button type="submit" class="w-100" variant="primary" @click.prevent="updateHubDetails()" :disabled="invalid">Save</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </modal>
</template>
<script>
import Modal from "@/components/Modal";
import { Option, Select, Radio, RadioGroup } from 'element-ui'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'
import {
notifyFunctionMixin,
helperFunctionMixin,
axios,
services,
getHeader
} from '@/assets/js/httpImports.js'
import { mapState, mapActions } from 'pinia'
import { useHubStore } from '@/stores/hubStore'

export default {
    props:{
        show_edit_hub: Boolean
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        [Option.name]: Option,
        [Select.name]: Select,
        [Radio.name]: Radio,
        [RadioGroup.name]: RadioGroup,
    },
    computed: {
        show: {
            get() {
                return this.show_edit_hub;
            },
            set(newVal) {
                this.$emit('update:show_edit_hub', newVal);
            },
        },

        ...mapState(useHubStore,['current_hub'])
    },
    data(){
        return {
            form: {
                // hub_id: '',
                hub_type_id: '',
                hub_name: '',
                user_id: '',
                hub_address: '',
                hub_target: '',
            },
            selectTypeOptions: [],
            selectHubManagerOptions: [],
        }
    },
    async created() {
        this.hubManagerList();

        this.$watch(
            () => this.current_hub,
            (newVal) => {
                if (newVal) {
                    // this.form.hub_id = newVal.hub_id ?? '';
                    this.form.hub_type_id = newVal.hub_type ? newVal.hub_type.hub_type_id : ''; 
                    this.form.hub_name = newVal.hub_name ?? '';
                    this.form.user_id = newVal.hub_manager.id ?? '';
                    this.form.hub_address = newVal.hub_address ?? '';
                    this.form.hub_target = newVal.hub_target ?? '';
                }
            },
            { immediate: true }
        )
    },
    methods: {
        ...mapActions(useHubStore,['getHub']),
        hubManagerList() {
            axios.get(services.access_control + 'user_list_by_role/hub manager', { headers: getHeader() })
            .then(response => {
                this.selectHubManagerOptions = response.data.data
            })
            .catch ( error => {
                this.errorFunction(error, "Showing Hub Listing failed: " + error.response.data.message) 
            });
        },
        updateHubDetails() {
            const postData = {
                hub_type_id: this.form.hub_type_id,
                hub_name: this.form.hub_name,
                user_id: this.form.user_id,
                hub_address:this.form.hub_address,
                hub_target: parseFloat(this.form.hub_target),
            }

            axios.put(services.hub + 'hubs/' + this.current_hub.hub_id , postData ,{ headers: getHeader() })
            .then ( response => {
                if (response.status === 200)
                {
                    this.$notify({
                    message:
                        '<b>Hub : ' + response.data.data.hub_name + '</b> - Successfully Updated.',
                    timeout: 10000,
                    icon: 'ni ni-bell-55',
                    type: 'default',
                    });
                    this.getHub(this.current_hub.hub_id)
                }
            })
            .catch ( error => {
                this.errorFunction(error)
            });
        }
    }
}
</script>